import { z } from "zod";

export const PaymentMethodSchema = z.enum([
  "CREDIT_CARD",
  "DEBIT_CARD",
  "ACH",
  "CASH",
  "CHECK",
  "OTHER",
  "UNKNOWN",
  "WIRE",
  "EFT",
]);
